import React from 'react';
import InputGroup from '../../InputGroup';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import { copyFor } from '../../../copy/copy';

const HomeAddressInput = props => (
    <Field
        name="homeAddressInput"
        component={InputGroup}
        type="text"
        label={copyFor('formFields', 'homeAddress')}
        placeholder={copyFor('placeholders', 'homeAddress')}
        autocomplete="off"
        maxLength={100}
        inputColor="#000"
        autoFocus={props.autoFocus}
    />
);

HomeAddressInput.propTypes = {
    autoFocus: PropTypes.bool
};

export default HomeAddressInput;



// WEBPACK FOOTER //
// ./src/components/LocalRep/Form/HomeAddressInput.jsx